<script lang="ts">
	import type { HTMLAttributes, HTMLButtonAttributes } from "svelte/elements";
	import loaderIcon from "@core/assets/icons/loader.svg?raw";
	import { ButtonLoadingBehaviour } from "./ButtonLoadingBehaviour.js";
	import type { ButtonSize } from "./ButtonSize.js";
	import type { ButtonVariant } from "./ButtonVariant.js";
	import Icon from "./Icon.svelte";
	import { getButtonClass, getButtonLoaderClass } from "./getButtonClass.js";

	const {
		variant,
		size,
		onclick,
		children,
		loading,
		loaderBehaviour = ButtonLoadingBehaviour.ForWideButton,
		type = onclick ? "button" : undefined,
		disabled,
		...rest
	}: {
		loading?: boolean;
		variant: ButtonVariant;
		size: ButtonSize;
		disabled?: boolean;
		loaderBehaviour?: ButtonLoadingBehaviour;
	} & (HTMLButtonAttributes | (HTMLAttributes<HTMLSpanElement> & { type: "span" })) = $props();
</script>

<svelte:element
	this={type === "span" ? "span" : "button"}
	type={type === "span" ? undefined : type}
	disabled={disabled === true || loading === true}
	{...rest}
	{onclick}
	class={[
		getButtonClass(variant, size),
		type === "span" && "w-fit",
		loading && "loading cursor-wait",
		loading && loaderBehaviour === ButtonLoadingBehaviour.ForNarrowButton && "!text-transparent",
		rest.class,
	]}
>
	{#if loading}
		<div
			class={[
				"absolute inset-y-0 flex items-center justify-center",
				loaderBehaviour === ButtonLoadingBehaviour.ForWideButton && "right-6",
				loaderBehaviour === ButtonLoadingBehaviour.ForNarrowButton && "inset-x-0",
			]}
		>
			<Icon
				icon={loaderIcon}
				class={["size-6 animate-[spin_1s_steps(8,_jump-end)_infinite_reverse] ", getButtonLoaderClass(variant)]}
			/>
		</div>
	{/if}
	{@render children?.()}
</svelte:element>
